import React from "react";
import {
  Row,
  Col,
  Button,
  Glyphicon,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import _ from "lodash";

import { uploadFile } from "../../../utils/uploadFile";
import { create } from "../../../utils/apiService";

import { updateVideo } from "../../../actions";

class MailingUpload extends React.Component {
  constructor() {
    super();

    this.state = {
      submitting: false
    };

    this.submitUpload = this.submitUpload.bind(this);
    this.createMailing = this.createMailing.bind(this);
    this.isValid = this.isValid.bind(this);
  }
  isValid() {
    const { video } = this.props;
    let textInput = this.textInput.value;
    let mailingsNames = video.mailings.map(mailing => mailing.name);

    // Should not be empty
    if (textInput === "") {
      toastr.error("Nome não deve ser vazio.");
      return false;
    }

    // Should not exist an equal name
    if (_.includes(mailingsNames, textInput)) {
      toastr.error("Nome já existe. Favor escolher outro.");
      return false;
    }

    return true;
  }
  submitUpload() {
    if (!this.isValid()) {
      return;
    }
    this.setState({ submitting: true });
    const { video } = this.props;
    let file = this.filesInput.files[0];
    if (file) {
      uploadFile(file, video)
        .then(res => {
          let fileUrl = res;
          this.createMailing(fileUrl);
          this.setState({ submitting: false });
        })
        .catch(err => {
          this.setState({ submitting: false });
        });
    } else {
      toastr.error("Nenhum arquivo para fazer upload");
      this.setState({ submitting: false });
    }
  }
  async createMailing(fileUrl) {
    const { video, updateVideo } = this.props;
    let textInput = this.textInput.value;
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}/mailings`;

    let data = {
      mailing: {
        name: textInput,
        data_path: fileUrl
      }
    };
    try {
      let response = await create(url, data);
      const updatedVideo = response.data;
      updateVideo(video.campaign_id, updatedVideo);
      this.resetInputs();
    } catch (err) {
      toastr.error("Ocorreu um erro ao salvar o mailing.");
    }
  }
  resetInputs() {
    this.textInput.value = "";
    this.filesInput.value = "";
  }
  render() {
    const tooltip = (
      <Tooltip id="tooltip">
        Esse nome será usado como filtro na visualização de estatísticas da
        campanha. Um exemplo de um bom nome seria "Repescagem 15/08 - 560
        usuários"
      </Tooltip>
    );
    return (
      <Row>
        <Col md={4}>
          <div className="form-group">
            <label>
              Nome:{" "}
              <OverlayTrigger placement="right" overlay={tooltip}>
                <Glyphicon glyph="question-sign" />
              </OverlayTrigger>
            </label>
            <input
              className="form-control"
              type="text"
              placeholder="Repescagem 15/08 - 560 usuários"
              ref={input => {
                this.textInput = input;
              }}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className="form-group">
            <label>Upload de arquivo:</label>
            <input
              tag="file"
              className="form-control"
              type="file"
              ref={input => {
                this.filesInput = input;
              }}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className="form-group">
            <Button
              style={{ marginTop: 25 }}
              onClick={this.submitUpload}
              disabled={this.state.submitting}
              bsStyle="primary"
            >
              Enviar
            </Button>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(MailingUpload);



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingUpload.js